// extracted by mini-css-extract-plugin
export var active = "_g6-c";
export var compactArrow = "_g6-5";
export var container = "_g6-0";
export var dot = "_g6-b";
export var dotContainer = "_g6-a";
export var hoverArrowButton = "_g6-7";
export var hoverArrowContainer = "_g6-6";
export var leftHoverArrowContainer = "_g6-8 _g6-6";
export var rightHoverArrowContainer = "_g6-9 _g6-6";
export var slide = "_g6-4";
export var sliderContainer = "_g6-1";
export var sliderContainerVisibleOverflow = "_g6-2";
export var sliderOverflow = "_g6-3";
export var vignetteBoth = "_g6-f";
export var vignetteLeft = "_g6-e";
export var vignetteRight = "_g6-d";